import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSort = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M3.6 5.65C3.6 5.075 4.05 4.6 4.625 4.6L15.35 4.6C15.925 4.6 16.4 5.075 16.4 5.65C16.4 5.9 16.3 6.125 16.15 6.3L12 11.425V15C12 15.45 11.625 15.8 11.175 15.8C11 15.8 10.825 15.75 10.675 15.625L8.375 13.8C8.125 13.6 8 13.325 8 13.025V11.425L3.825 6.3C3.675 6.125 3.6 5.9 3.6 5.65ZM4.975 5.8L9.05 10.825C9.15 10.95 9.2 11.075 9.2 11.2V12.925L10.8 14.2V11.2C10.8 11.075 10.825 10.95 10.925 10.825L15.025 5.8L4.975 5.8Z"
	})
});
const ForwardRef = forwardRef(SvgSort);
export default ForwardRef;
